import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { CompanyComponent } from './company.component';
import { AddcompanyComponent } from '../addcompany/addcompany.component';
import { EditcompanyComponent } from '../editcompany/editcompany.component';
import { DetailcompanyComponent } from '../detailcompany/detailcompany.component';
import { CompanyAttachmentComponent } from '../company-attachment/company-attachment.component';

const routes: Routes = [
  {
    path: 'company-list', component: CompanyComponent
  },
  {
    path: "addcompany",
    component: AddcompanyComponent,
  },
  {
    path: "editcompany/:id",
    component: EditcompanyComponent,
    data: {
      allowedRoles: ["maven", "company"],
    },
    children: [
      {
        path: "editcompany",
        component: EditcompanyComponent,
        data: {
          allowedRoles: ["maven", "company", "company-list"],
        },
      },
      {
        path: "company-attachment",
        component: CompanyAttachmentComponent,
        data: {
          allowedRoles: ["maven", "company", "company-list"],
        },
      },
    ],
  },
  {
    path: "detailcompany/:id",
    component: DetailcompanyComponent
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes), NgbModule],
  exports: [RouterModule]
})
export class CompanyRoutingModule { }
